export enum AccountSettingsModalResolvedValues {
  CHANGE_PASSWORD = '[Account Settings Modal] Change Password',
}
